/**
 * SAB-1044: how long before kickoff the lineup reminder fires, stated once.
 *
 * The settings toggle said "Thursday morning reminder to set your lineup". The day was
 * wrong for the season it was written for -- week 1 of 2026 opens on WEDNESDAY Sept 9 --
 * and the cron behind it had been disabled on prod since May without the toggle changing.
 *
 * The reminder is now relative to the week's FIRST kickoff, whatever weekday that is, so
 * the copy must not name a day at all. It names an offset, and the offset is the edge
 * function's own constant.
 *
 * The client cannot import from a Deno edge function, so this is the sweep's second
 * option: a value here, and nflLineupReminder.test.ts reading the function's source and
 * failing if the two diverge.
 */

/** Minutes before the week's first kickoff that the reminder is sent. */
export const LINEUP_REMINDER_WINDOW_MINUTES = 30;

/** The settings-toggle description. One phrasing, derived from the offset above. */
export const LINEUP_REMINDER_TOGGLE_DESC =
  `Reminder ${LINEUP_REMINDER_WINDOW_MINUTES} minutes before your week's first game`;
